import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { store } from "./store";
import { Pagination, PagingParams } from "../models/pagination";
import {
  IBrandData,
  IProductCategory,
  ProductCategory,
} from "../models/product";
import { toast } from "react-toastify";
import { IOrderItem, IOrderItemUpdate } from "../models/orders";

export default class OrderStore {
  loading = false;
  loadingInitial = "";
  dashLoadingInitial = "";
  pagination: Pagination | null = null;
  pagingParams = new PagingParams();
  vendorOrderItemList: IOrderItem[] = [];
  vendorPendingOrderItemList: IOrderItem[] = [];
  vendorCompletedOrderItemList: IOrderItem[] = [];
  vendorCancelledOrderItemList: IOrderItem[] = [];
  vendorReturnedOrderItemList: IOrderItem[] = [];

  constructor() {
    makeAutoObservable(this);

    // reaction(
    //   () => this.predicate.keys(),
    //   () => {
    //     this.pagingParams = new PagingParams();
    //     this.activityRegistry.clear();
    //     this.loadActivities();
    //   }
    // );
  }

  setLoading = (x: boolean) => {
    this.loading = x;
  };


  getVendorOrders = async (searchTerm : string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Orders.getVendorOrders(
        store.commonStore.loggedInUser!.userId,
        searchTerm
      );
      if (response.isSuccessful && response.data){
        
        runInAction(() => {
          if (response.data) {
            this.vendorOrderItemList = response.data;
            this.vendorPendingOrderItemList = response.data.filter((item: { status: string; }) => {
              return item.status === "Pending";
            });
            this.vendorCompletedOrderItemList = response.data.filter((item: { status: string; }) => {
              return item.status === "Completed";
            });
            this.vendorCancelledOrderItemList = response.data.filter((item: { status: string; }) => {
              return item.status === "Cancelled";
            });
            this.vendorReturnedOrderItemList = response.data.filter((item: { status: string; }) => {
              return item.status === "Returned";
            });
          }
        });
      }
      else {
        toast.info(response.responseMessage)
        this.vendorOrderItemList = [];
        this.vendorPendingOrderItemList = [];
        this.vendorCompletedOrderItemList = [];
        this.vendorCancelledOrderItemList = [];
        this.vendorReturnedOrderItemList = []
      };
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  updateOrder = async (creds: IOrderItem) => {
    this.loading = true;
    try {
      const payload: IOrderItemUpdate = {
        orderId: creds.orderId,
        status: "Completed",
      };
      const response = await agent.Orders.updateOrder(payload);
      if (response.isSuccessful) {
        await this.getVendorOrders("");
        toast.info(response.responseMessage);
        runInAction(() => (this.loading = false));
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
        });

      return response;
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };
  updateOrders = async (creds: IOrderItem[]) => {
    this.loading = true;
    try {
      const payload = creds.map((cred) => {
        return {
          orderId: cred.orderId,
          status: "Completed",
        };
      });
      const response = await agent.Orders.updateMultipleOrders(payload);
      if (response.isSuccessful) {
        await this.getVendorOrders("");
        toast.info(response.responseMessage);
        runInAction(() => (this.loading = false));
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
        });

      return response;
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };
}
